import Home from "./componenets/Home";
import "./styles.css";

export default function App() {
  return (
    <div className="app">
      <Home />
    </div>
  );
}
